import { render } from "./InvoicesTable.vue?vue&type=template&id=17bf719c&scoped=true"
import script from "./InvoicesTable.vue?vue&type=script&lang=js"
export * from "./InvoicesTable.vue?vue&type=script&lang=js"

import "./InvoicesTable.vue?vue&type=style&index=0&id=17bf719c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bf719c"]])

export default __exports__